import React, { FC } from 'react';
import styles from './BigInputField.module.css';
interface BigInputFieldProps {
  content: string;
  setContent: (content: string) => void;
  placeholder?: string;
  readOnly?: boolean;
}

const BigInputField: FC<BigInputFieldProps> = ({
  content,
  setContent,
  placeholder = 'Please enter some text...',
  readOnly,
}) => {
  return (
    <>
      <textarea
        className={styles.bigInput}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={placeholder}
        readOnly={readOnly}
      ></textarea>
    </>
  );
};

export default BigInputField;
